const PigGenderType = {
	MALE: { value: 'MA', title: 'common.male' },
	FEMALE: { value: 'FE', title: 'common.female' },
	MIXED: { value: 'MI', title: 'common.mixed' }
};

PigGenderType.getAll = () => ([
	PigGenderType.MALE,
	PigGenderType.FEMALE,
	PigGenderType.MIXED,
]);

PigGenderType.getByValue = value => {
	switch (value) {
		case PigGenderType.MALE.value:
			return PigGenderType.MALE;
		case PigGenderType.FEMALE.value:
			return PigGenderType.FEMALE;
		case PigGenderType.MIXED.value:
			return PigGenderType.MIXED;
	}

	return null;
};

export default Object.freeze(PigGenderType);